// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"9d55ea23","142":"f25b4207","237":"d7fbf32d","483":"4db3d461","624":"54ecf85c","670":"7feba449","749":"e481f974"}[chunkId] + ".chunk.js";
};